import { Expose, Type } from "class-transformer";
import { BaseModel } from "src/shared/models/base.model";

export enum Status {
    PENDING = "PENDING",
    COMPLETED = "COMPLETED",
    NOT_STARTED = "NOT STARTED",
    IN_PROCESS = "IN_PROCESS",
    PAID = "PAID",
    APPROVED = "APPROVED",
    REJECTED = "REJECTED",
    REJECTED_USER = "REJECTED_USER",
}

export type HouseholdClaimStepTrackingTitle =
    | ""
    | "Entrega de documentos"
    | "Evaluación"
    | "Documentos adicionales"
    | "Solicitud de ajustador"
    | "Pago"
    | "Reevaluación";

export class HouseholdClaimStepTracking extends BaseModel {
    @Expose() title: HouseholdClaimStepTrackingTitle = "";
    @Expose() status = Status.PENDING;
    @Expose() statusLabel = "";
    @Expose() observation = "";
    @Expose() date = "";
    @Expose() createdDate = "";
    @Expose() bank = "";
    @Expose() bankAccount = "";
    @Expose() indemnityAmount = 0;
    @Expose() currency = "";
}

export class HouseholdClaimTrackingDigital extends BaseModel {
    @Expose() id = "";
    @Expose() title = "";
    @Expose() policeNumber = "";
    @Expose() productCode = "";
    @Expose() sinisterNumber = "";
    @Expose() address = "";
    @Expose() reevaluate = 0;
    @Expose() help: string | null = null;
    @Expose() popup = false;
    @Expose()
    @Type(() => HouseholdClaimStepTracking)
    steps: HouseholdClaimStepTracking[] = [];
}
